import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

class PortalWrapper extends React.Component {
  constructor() {
    super();
    // 1: Create a new div that wraps the component
    this.el = document.createElement("div");
  }

  static propTypes = {
    children: PropTypes.node.isRequired
  };

  // 2: Append the element to the DOM when it mounts
  componentDidMount = () => {
    const portalRoot = document.getElementById("portals");
    if (portalRoot) {
      portalRoot.appendChild(this.el);
    }
  };
  // 3: Remove the element when it unmounts
  componentWillUnmount = () => {
    const portalRoot = document.getElementById("portals");
    if (portalRoot) {
      portalRoot.removeChild(this.el);
    }
  };
  render() {
    // 4: Render the element's children in a Portal
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

export default PortalWrapper;
